import * as Constants from '../Constants.js';

export const Method = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const FetchLista = async (url) => {
  const result = await FetchObject(url);
  return result === null ? [] : result;
};

export const FetchObject = async (url) => {
  try {
    const response = await fetch(Constants.URLBASE + '/' + url, {
      method: Method.GET,
      redirect: 'follow',
      credentials: 'include',
    });

    if (response.status === 401) {
      document.location.href = '/nosession';
    } else if (response.redirected) {
      document.location = response.url;
    }

    if (response.status === 204) {
      return null;
    } else {
      const environment = await safeParseEnvelope(response);
      if (environment.ok) {
        return environment.data ?? null;
      }
      throw new Error(joinErrors(environment.errors) || 'Error al obtener datos');
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const SaveObject = async (method, url, dto) => {
  try {
    const response = await fetch(Constants.URLBASE + '/' + url, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dto),
      redirect: 'follow',
      credentials: 'include',
    });

    if (response.status === 401) {
      document.location.href = '/nosession';
    } else if (response.redirected) {
      document.location = response.url;
    }

    if (response.status !== 204) {
      const environment = await safeParseEnvelope(response);
      if (!environment.ok) {
        throw new Error(joinErrors(environment.errors) || 'Error al grabar los datos');
      }
      // Compatibilidad: preferir Location si existe; sino, devolver data
      if (method === Method.POST) {
        const loc = response.headers.get('Location');
        if (loc) {
          const splitURL = loc.split('/');
          return splitURL[splitURL.length - 1];
        }
        return environment.data ?? null;
      }
    }
    return null;
  } catch (error) {
    console.log('SaveObject - catch', error);
    throw new Error(error.message);
  }
};

export const SearchLista = async (url, filtros) => {
  try {
    const response = await fetch(Constants.URLBASE + '/' + url, {
      method: Method.POST,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(filtros),
      redirect: 'follow',
      credentials: 'include',
    });

    if (response.status === 401) {
      document.location.href = '/nosession';
    } else if (response.redirected) {
      document.location = response.url;
    }

    if (response.status === 204) {
      return [];
    } else {
      const environment = await safeParseEnvelope(response);
      if (environment.ok) {
        return environment.data ?? [];
      }
      throw new Error(joinErrors(environment.errors) || 'Error en la búsqueda');
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

// ===== Helpers =====
const joinErrors = (errs) => {
  if (!errs) return '';
  if (Array.isArray(errs)) return errs.join(' | ');
  if (typeof errs === 'string') return errs;
  return String(errs);
};

const safeParseEnvelope = async (response) => {
  try {
    const json = await response.json();
    // Soporta backends antiguos o el nuevo { data, errors, ok }
    if (json && typeof json === 'object') {
      const errors = json.errors ?? json.errores ?? null;
      const okField = typeof json.ok === 'boolean' ? json.ok : undefined;
      if (okField !== undefined || 'data' in json || 'errors' in json || 'errores' in json) {
        return {
          ok: okField === undefined ? !errors : okField,
          data: json.data ?? null,
          errors: errors,
        };
      }
      // Fallback: tratar todo json como data
      return { ok: true, data: json, errors: null };
    }
    return { ok: false, data: null, errors: ['Respuesta inválida del servidor'] };
  } catch {
    // Si no hay body (204) u otro error de parseo
    if (response.status === 204) return { ok: true, data: null, errors: null };
    return { ok: false, data: null, errors: ['No se pudo interpretar la respuesta'] };
  }
};
